import { baseApi } from '../axios';

export const createResume = async () => {
	const response = await baseApi.get(`/resume/create`);
	return response;
};

export const getResumes = async () => {
	const response = await baseApi.get(`/resume/get`);
	return response;
};
